<div class="list-page">
  <div class="list-page__add-block list-page__add-block--sloka-list">
    <input-cmp
      class="select-sloka-type-block select-block"
      isSelectSlokasList="true"
      placeholder="Select Sloka Type"
      *ngIf="slokaTypesList$ | async as list"
      [list]="list"
      (output)="setSlokaTypeId($event)"
    ></input-cmp>
    <button-cmp
      class="add-button-block"
      (click)="onAddButtonClick()"
      isLogin="false"
      isAdd="true"
      title="Add Sloka"
    ></button-cmp>
  </div>
  <div class="list-page__table-block">
    <table-cmp
      *ngIf="slokasList$ | async as list"
      [isSlokaType]="false"
      [table-data]="list.slice().reverse()"
      [page]="page"
      (action)="receivedAction($event)"
      class="table-block"
    ></table-cmp>
  </div>
  <div class="list-page__pagination-block">
    <pagination-controls
      class="table-paginate"
      (pageChange)="page = $event"
    ></pagination-controls>
  </div>
</div>
